// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2gGd6","title":"AfterImages45_title__2qcM2","images":"AfterImages45_images__zKd-r"};